<template>
    <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
        <div @mouseenter="show = true" @mouseleave="show = false">
            <QuestionMarkCircleIcon class="w-5 h-5 text-gray-400" />
        </div>
        <transition
            enter-active-class="duration-200 ease-out z-10"
            enter-from-class="opacity-0 scale-95 z-10"
            enter-to-class="opacity-100 scale-100 z-10"
            leave-active-class="duration-100 ease-in z-10"
            leave-from-class="opacity-100 scale-100 z-10"
            leave-to-class="opacity-0 scale-95 z-10"
        >
            <div
                v-if="show"
                class="absolute bottom-0 right-2.5 -ml-20 -mr-4 sm:-mx-12 flex flex-col items-center mb-8"
            >
                <span
                    class="relative z-10 p-2 text-xs text-white whitespace-no-wrap bg-gray-800 rounded shadow-lg"
                    >{{ message }}</span
                >
                <div
                    class="relative -right-8 sm:right-0 w-3 h-3 -mt-2 rotate-45 bg-gray-800 z-20"
                ></div>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { QuestionMarkCircleIcon } from "@heroicons/vue/solid";

defineProps<{
    message?: string;
}>();

const show = ref(false);
</script>
